/* Get Sibling */
const getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

/* Slide Up */
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* Slide Down */
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

document.addEventListener("DOMContentLoaded", function () {
  // Check window width on load
  if (window.innerWidth < 750) {
    initializeMobileMenu();
  }

  // Also check on window resize
  window.addEventListener("resize", function () {
    if (window.innerWidth < 750) {
      initializeMobileMenu();
    }
  });
});

function initializeMobileMenu() {
  const offcanvasMenu = document.querySelectorAll(".offcanvas__menu");
  // Only initialize if not already initialized
  if (document.querySelector(".offcanvas__sub_menu_toggle")) {
    return;
  }

  /* Add a Button For SubMenu Toggle */
  offcanvasMenu.forEach((item) => {
    item.querySelectorAll(".offcanvas__sub_menu").forEach(function (ul) {
      const subMenuToggle = document.createElement("button");
      subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
      subMenuToggle.setAttribute("aria-label", "menu collapse");
      ul.parentNode.appendChild(subMenuToggle);
    });
  });

  /* Open/Close Sub Menu On Click Toggle Button */
  offcanvasMenu.forEach((offcanvasMenuitem) => {
    offcanvasMenuitem
      .querySelectorAll(".offcanvas__sub_menu_toggle")
      .forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          const parent = this.parentElement;
          if (parent.classList.contains("active")) {
            this.classList.remove("active");
            parent.classList.remove("active");
            parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                if (typeof slideUp === "function") {
                  slideUp(subMenu);
                }
              });
          } else {
            this.classList.add("active");
            parent.classList.add("active");
            if (typeof slideDown === "function") {
              slideDown(this.previousElementSibling);
            }
            if (typeof getSiblings === "function") {
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                  .querySelectorAll(".offcanvas__sub_menu")
                  .forEach(function (subMenu) {
                    subMenu.parentElement.classList.remove("active");
                    subMenu.nextElementSibling.classList.remove("active");
                    if (typeof slideUp === "function") {
                      slideUp(subMenu);
                    }
                  });
              });
            }
          }
        });
      });
  });
}
